var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphonesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 498.28 498.28",
    height: 512,
    viewBox: "0 0 498.28 498.28",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m480.78 373.45c-4.142 0-7.5-3.358-7.5-7.5v-88.136c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v88.136c0 4.142-3.358 7.5-7.5 7.5z",
    fill: "#fd8087"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.642 391.087c-4.142 0-7.5-3.358-7.5-7.5v-110.773c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v110.772c0 4.143-3.358 7.501-7.5 7.501z",
    fill: "#fd8087"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m497.547 298.275.241-15.687c2.101-136.816-108.134-248.756-244.966-248.756h-.001c-136.832 0-250.505 111.941-252.606 248.757l-.215 13.994c-.035 2.261 1.788 4.112 4.049 4.112h25.903c2.212 0 4.015-1.775 4.049-3.988l.239-15.593c.869-56.602 23.243-111.023 63.411-150.911 40.514-40.232 94.281-62.402 151.272-62.402 1.129 0 2.242.008 3.375.026 57.852.888 111.862 24.446 151.903 66.295 39.356 41.133 60.38 96.459 59.506 153.38l-.164 10.698c-.021 1.372 1.086 2.496 2.458 2.496h29.086c1.345-.001 2.439-1.078 2.46-2.421z",
    fill: "#07689f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.83 361.158h47.376v83.984h-47.376z",
    fill: "#fd8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.642 459.35c-9.493 0-17.188-7.695-17.188-17.188v-78.024c0-9.493 7.695-17.188 17.188-17.188 9.493 0 17.188 7.695 17.188 17.188v78.024c0 9.493-7.696 17.188-17.188 17.188z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.216 361.158h50.376v83.984h-50.376z",
    fill: "#fd8087",
    transform: "matrix(-1 0 0 -1 896.809 806.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.78 459.35c9.493 0 17.188-7.695 17.188-17.188v-78.024c0-9.493-7.695-17.188-17.188-17.188-9.493 0-17.188 7.695-17.188 17.188v78.024c0 9.493 7.695 17.188 17.188 17.188z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.061 308.473-10.744 25.219v150.318l10.744 13.812c17.21 0 31.16-13.95 31.16-31.15v-127.04c0-17.209-13.95-31.159-31.16-31.159z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.361 308.473c-17.21 0-31.16 13.95-31.16 31.16v127.04c0 17.2 13.95 31.15 31.16 31.15l14.398-19.011v-136.784z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#07689f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m404.061 308.473v189.35h-25.8c-6.84 0-12.38-5.54-12.38-12.38v-164.59c0-6.83 5.54-12.38 12.38-12.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.541 320.853v164.59c0 6.84-5.54 12.38-12.38 12.38h-25.8v-189.35h25.8c6.84 0 12.38 5.55 12.38 12.38z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesLogo);
export default __webpack_public_path__ + "static/media/headphonesLogo.8913a64d4a709fcfe8b6eac53e899e5c.svg";
export { ForwardRef as ReactComponent };